import React, { useRef, useEffect, useState } from "react";
import "./ArchiveItem.css";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";

const ArchiveItem = ({ item, type }) => {
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  // Muted, deliberately. Every browser refuses autoplay on a video with
  // sound, so starting unmuted meant play() was rejected and /spectacle --
  // a page in the main navigation -- rendered as a black rectangle for
  // every visitor. Sound stays one tap away on the speaker control.
  const [isMuted, setIsMuted] = useState(true);
  const [loading, setLoading] = useState(false); // Loader state
  const [showMore, setShowMore] = useState(false);
  // The real shape of this piece of media, read from the file itself rather
  // than assumed. A vertical clip and a landscape clip need opposite layouts,
  // and the archive holds both. Null until the browser reports it; the CSS
  // default is a safe centred contain, so nothing is broken while we wait.
  const [ratio, setRatio] = useState(null);

  const readRatio = (w, h) => {
    if (w > 0 && h > 0) setRatio(w / h);
  };


  useEffect(() => {
    const mediaElement = videoRef.current || audioRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isPlaying) {
          setIsPlaying(true);
          if (type === "video" && videoRef.current) {
            videoRef.current.play().catch((err) => console.error("Video play error:", err));
          } else if (type === "audio" && audioRef.current) {
            audioRef.current.play().catch((err) => console.error("Audio play error:", err));
          }
        } else if (!entry.isIntersecting && isPlaying) {
          setIsPlaying(false);
          if (type === "video" && videoRef.current) {
            videoRef.current.pause();
          } else if (type === "audio" && audioRef.current) {
            audioRef.current.pause();
          }
        }
      },
      { threshold: 0.5 }
    );

    if (mediaElement) {
      observer.observe(mediaElement);
    }

    return () => {
      if (mediaElement) {
        observer.unobserve(mediaElement);
      }
    };
  }, [isPlaying, type]);

  useEffect(() => {
    // Handle mute functionality for both video and audio
    if (audioRef.current) {
      audioRef.current.muted = isMuted;
    }
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
    }
  }, [isMuted]);

  const toggleMute = () => {
    setIsMuted((prev) => !prev); 
  };

  return (
    <div
      className={`archive-item${
        ratio === null ? "" : ratio < 1 ? " is-portrait" : " is-landscape"
      }`}
      style={ratio ? { "--media-ratio": ratio } : undefined}
    >
      {type === "video" ? (
        <div className="video-container">
          <video
            ref={videoRef}
            src={`https://riymay.com/assets/${item.url}`}
            className="archive-video"
            // Set on the element, not only through the ref effect. Effects run
            // in declaration order and the intersection observer above calls
            // play() from its own effect -- so relying on the mute effect
            // having run first is a race. The attribute is correct from the
            // very first render, which is what the autoplay policy checks.
            muted={isMuted}
            // The still shown in the frame until playback starts. Without it
            // the player is a black rectangle, which on a page built for
            // people to stop and watch is where they scroll past instead.
            // Older entries have no thumbnail; the attribute is simply
            // omitted for those and nothing changes for them.
            poster={item.thumbnail ? `https://riymay.com/assets/${item.thumbnail}` : undefined}
            loop
            playsInline
            // Without this the browser is free to start pulling every clip in
            // the feed before anyone scrolls to it. Playback is already driven
            // by the observer below, so metadata is all we need up front.
            preload="metadata"
            onLoadedMetadata={(e) =>
              readRatio(e.currentTarget.videoWidth, e.currentTarget.videoHeight)
            }
          />
          
          {/* <video
            className="background-video"
            src={`https://riymay.com/assets/${item.url}`}
            autoPlay
            muted={isMuted}
            loop
          ></video> */}
        </div>
      ) : (
        <div className="audio-item">
          <img
            src={`https://riymay.com/assets/${item.urls[0].imageUrl}`}
            alt={item.title}
            className="audio-image"
            onLoad={(e) =>
              readRatio(e.currentTarget.naturalWidth, e.currentTarget.naturalHeight)
            }
          />
          <audio
            ref={audioRef}
            src={`https://riymay.com/assets/${item.urls[0].audioUrl}`}
            className="archive-audio"
            loop
            preload="auto"
            controls
          />
        </div>
      )}
{/*       
      <button
        className={`mute-button  ${isMuted ? "muted" : ""}`}
        onClick={toggleMute}
      >
        {isMuted ? "Unmute" : "Mute"}
      </button> */}


       <div className="video-mute-button" onClick={toggleMute}>
              <span>
                {" "}
                {isMuted ? <FaVolumeMute size={20} /> : <FaVolumeUp size={20} />}
              </span>
            </div>


            <div className="video-archive">
      {/* Video Title */}
      <h3 className="video-title">{item.title}</h3>

      {/* vido Description */}
      <p className={`video-description ${showMore ? "expanded" : ""}`}>
        {showMore ? item.description : `${item.description.slice(0, 100)}...`}
      </p>

      {/* Show More / Show Less Button */}
      {item.description.length > 100 && (
        <span className="show-more-btn" onClick={() => setShowMore(!showMore)}>
          {showMore ? "Show Less" : "Show More"}
        </span>
      )}
    </div>
    </div>
  );
};

export default ArchiveItem;